<template lang="pug">
div
  // Header row para desktop
  div.container.d-none.d-md-block
    b-row
      b-col(cols='6').d-flex.justify-content-flex-start.align-items-center
        b-icon.back-arrow.h3.cursor-pointer(
          icon="arrow-left-square-fill"
          variant=""
          @click="$router.go(-1)"
        )
        div.pl-3.d-flex.flex-column.align-items-start
          h4.title Excepciones OV
          nav.breadcrumb-custom
            span Inicio
            span.separator /
            span Excepciones
            span.separator /
            span Excepciones OV
      b-col(cols='6').d-flex.justify-content-end.align-items-center.mb-2
        div.position-relative.search-container
          b-icon(icon="search" class="search-icon")
          b-form-input(
            v-model="searchTerm"
            placeholder="Buscar por OV / RMA / N° de Serie"
            @keydown.enter="handleSearch"
            class="search-input"
          )

    div
      b-tabs(pills card lazy v-model="tabSelected" @activate-tab="onTabChange")
        b-tab(
          v-for="(tab, index) in tabs"
          :key="index"
          :title="`${tab.label} (${tab.count})`"
        )

      b-row
        b-col
          b-card(no-body)
            div.text-center.py-5(v-if="loading")
              b-spinner(variant="warning" label="Cargando...")
            b-table(
              v-else
              :items="exceptions"
              :fields="fields"
              responsive
              striped
              hover
              show-empty
              empty-text="No hay excepciones"
              class="mb-0"
            )
              template(#cell(fecha_creacion)="data")
                | {{ formatDate(data.value) }}
              
              template(#cell(tipo)="data")
                | {{ data.value }}
              
              template(#cell(solicitado_por)="data")
                | {{ data.value || '-' }}

              template(#cell(rma)="data")
                | {{ data.value || '-' }}

              template(#cell(numero_serie_equipo)="data")
                | {{ data.value || '-' }}

              template(#cell(acciones)="data")
                b-button(
                  size="sm"
                  variant="warning"
                  @click="openExceptionModal(data.item)"
                )
                  b-icon-gear(aria-hidden="true")
                  | Acciones
          
          div.d-flex.justify-content-end.my-3(v-if="totalRows > 0")
            b-pagination(
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="20"
              align="right"
              prev-text="Ant."
              next-text="Sig."
              aria-controls="my-table"
              @change="handlePageChange"
            )

    b-modal(
      id="confirmation-modal"
      :title="modalTitle"
      centered
      :ok-title="modalOkTitle"
      cancel-title="Cancelar"
      ok-variant="warning"
      cancel-variant="light"
      @ok="confirmAction"
      title-class="font-weight-bold"
    )
      p.mb-2 {{ modalDescription }}
      div(v-if="itemToProcess && itemToProcess.comentario")
        p.font-weight-bold.mb-1 Comentario:
        p.text-muted.mb-3 {{ itemToProcess.comentario }}
      p.font-weight-bold.mb-3 {{ modalMessage }}

    //- Modal de detalle de excepción
    ExceptionDetailModal(
      v-if="showExceptionModal"
      :exception-id="selectedExceptionId"
      :visible="showExceptionModal"
      @close="closeExceptionModal"
      @action-completed="handleExceptionAction"
    )

</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { wsClient } from '../../utils/websocket'
import ExceptionDetailModal from './ExceptionDetailModal.vue'

export default {
  name: 'ListExceptionsOV',
  components: {
    ExceptionDetailModal,
  },
  data() {
    return {
      searchTerm: '',
      exceptions: [],
      totalRows: 0,
      currentPage: 1,
      tabSelected: 0,
      tabs: [
        {
          label: 'Pendientes',
          key: 'pendientes',
          value: 'PENDIENTE',
          count: 0,
        },
        { label: 'Aprobadas', key: 'aprobadas', value: 'APROBADO', count: 0 },
        {
          label: 'Rechazadas',
          key: 'rechazadas',
          value: 'RECHAZADO',
          count: 0,
        },
        { label: 'Todas', key: 'total', value: 'TODAS', count: 0 },
      ],
      fields: [
        { key: 'ov_id', label: 'O.V.', sortable: true, tdClass: 'id-column' },
        { key: 'fecha_creacion', label: 'Fecha', sortable: true },
        { key: 'tipo', label: 'Tipo' },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'solicitado_por', label: 'Solicitado por' },
        { key: 'rma', label: 'RMA' },
        { key: 'numero_serie_equipo', label: 'N° de Serie' },
        {
          key: 'acciones',
          label: 'Acciones',
          class: 'text-center',
          tdClass: 'actions-column',
        },
      ],
      itemToProcess: null,
      actionType: null,
      loading: false,
      // Modal de detalle
      showExceptionModal: false,
      selectedExceptionId: null,
    }
  },
  async created() {
    await this.fetchCounts()
    // Busqueda inicial por estado pendiente
    this.fetchExceptions(this.tabs[0].value, 1)

    // Escuchar actualizaciones de excepciones vía websocket
    this.unsubscribeExceptions = wsClient.on('excepcion:updated', () => {
      this.fetchCounts()
      this.fetchExceptions(this.tabs[this.tabSelected].value, this.currentPage)
    })
  },
  computed: {
    modalTitle() {
      return this.actionType === 'approve'
        ? 'Aprobación de Excepción'
        : 'Rechazo de Excepción'
    },
    modalMessage() {
      return this.actionType === 'approve'
        ? '¿Quieres aprobar esta excepción?'
        : '¿Quieres rechazar esta excepción?'
    },
    modalOkTitle() {
      return this.actionType === 'approve' ? 'Aprobar' : 'Rechazar'
    },
    modalDescription() {
      if (!this.itemToProcess) return ''
      const action = this.actionType === 'approve' ? 'aprobando' : 'rechazando'
      return `Estás ${action} una Excepción para la OV ${
        this.itemToProcess.ov_id
      }, por ${this.itemToProcess.tipo || 'ajuste de bono'}`
    },
  },
  methods: {
    ...mapActions('OVStore', [
      'listExceptions',
      'manageException',
      'getExceptionCounts',
    ]),

    async fetchCounts() {
      try {
        const counts = await this.getExceptionCounts()
        // Update counts in tabs
        this.tabs.forEach((tab) => {
          if (counts[tab.key] !== undefined) {
            tab.count = counts[tab.key]
          }
        })
      } catch (error) {
        console.error('Error fetching counts:', error)
      }
    },

    async fetchExceptions(estado, page = 1) {
      this.loading = true
      try {
        const response = await this.listExceptions({
          estado,
          page,
          search: this.searchTerm,
        })
        this.exceptions = response.results
        this.totalRows = response.count
      } catch (error) {
        console.error('Error fetching exceptions:', error)
        this.$bvToast.toast('Error al cargar las excepciones', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.currentPage = 1
      this.fetchExceptions(this.tabs[this.tabSelected].value, 1)
    },

    onTabChange(index) {
      this.currentPage = 1
      const selectedTab = this.tabs[index]
      this.fetchExceptions(selectedTab.value, 1)
    },

    formatDate(date) {
      if (!date) return '-'
      return moment(date).format('DD/MM/YYYY HH:mm')
    },

    approveException(item) {
      this.itemToProcess = item
      this.actionType = 'approve'
      this.$bvModal.show('confirmation-modal')
    },

    rejectException(item) {
      this.itemToProcess = item
      this.actionType = 'reject'
      this.$bvModal.show('confirmation-modal')
    },

    async confirmAction() {
      if (!this.itemToProcess) return

      const isApprove = this.actionType === 'approve'
      const estado = isApprove ? 'approved' : 'reject'
      const successMsg = isApprove
        ? 'Excepción aprobada correctamente'
        : 'Excepción rechazada correctamente'
      const errorMsg = isApprove
        ? 'Error al aprobar la excepción'
        : 'Error al rechazar la excepción'

      try {
        await this.manageException({
          ov_id: this.itemToProcess.ov_id,
          estado,
        })
        this.$bvToast.toast(successMsg, {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })
        await this.fetchCounts()
        this.fetchExceptions(
          this.tabs[this.tabSelected].value,
          this.currentPage
        )
      } catch (error) {
        this.$bvToast.toast(errorMsg, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.itemToProcess = null
        this.actionType = null
      }
    },

    // Métodos para modal de detalle
    openExceptionModal(item) {
      this.selectedExceptionId = item.id
      this.showExceptionModal = true
    },

    closeExceptionModal() {
      this.showExceptionModal = false
      this.selectedExceptionId = null
    },

    async handleExceptionAction() {
      // Refrescar datos después de aprobar/rechazar
      await this.fetchCounts()
      this.fetchExceptions(this.tabs[this.tabSelected].value, this.currentPage)
      this.closeExceptionModal()
    },
  },
  beforeDestroy() {
    if (this.unsubscribeExceptions) {
      this.unsubscribeExceptions()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

::v-deep .card-header-pills {
  display: flex;
  gap: 10px;
  padding: 10px;
  background-color: #fff;
  border-radius: 10px;
}

::v-deep .card-header {
  background-color: #fff;
  border-bottom: none;
  padding: 0;
}

::v-deep .nav-item {
  flex: 1 1 0;
  margin: 0;
}

::v-deep .nav-item a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding: 0 10px;
  border-radius: 8px;
  color: $samtek-grey;
  font-weight: 700;
  transition: background-color 0.2s ease;
}

::v-deep .nav-item a:hover {
  background-color: $center-bg;
  color: $samtek-grey;
}

::v-deep .nav-pills .nav-link.active,
::v-deep .nav-pills .show > .nav-link {
  background-color: $samtek-yellow;
  color: $samtek-black;
  font-weight: 700;
  border-radius: 8px;
}

::v-deep .back-arrow {
  color: $samtek-yellow;
  font-size: 24px;
  border-radius: 5px;
  cursor: pointer;
}

.title {
  font-size: 20px;
  font-weight: 700;
  color: $samtek-black;
}

.breadcrumb-custom {
  margin-top: 8px;
  font-size: 15px;
  color: $samtek-grey;
}

.breadcrumb-custom .separator {
  margin: 0 6px;
}

::v-deep .tab-content > .active {
  display: none;
}
$sort-svg: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>";
$sort-up: "<path fill='%23525252' d='M50 8l38 44H12z'/>";
$sort-up-soft: "<path fill='%23525252' opacity='.5' d='M50 8l38 44H12z'/>";
$sort-down: "<path fill='%23525252' d='M50 92L12 48h76z'/>";
$sort-down-soft: "<path fill='%23525252' opacity='.5' d='M50 92L12 48h76z'/>";
$sort-end: "</svg>";

$sort-icon: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down-soft}#{$sort-end}");
$sort-icon-asc: url("#{$sort-svg}#{$sort-up}#{$sort-down-soft}#{$sort-end}");
$sort-icon-desc: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down}#{$sort-end}");

::v-deep .b-table thead th {
  background-color: $table-head-bg;
  color: $samtek-grey;
  border: none;
  height: 50px;
  padding-left: 40px;
  padding-right: 40px;
  font-size: 16px;
  font-weight: 700;
  vertical-align: middle;
}

::v-deep .b-table thead th.sorting,
::v-deep .b-table thead th.sorting_asc,
::v-deep .b-table thead th.sorting_desc {
  background-size: 16px 16px;
  background-position: right 16px center;
}

::v-deep .b-table thead th.sorting {
  background-image: $sort-icon;
}

::v-deep .b-table thead th.sorting_asc {
  background-image: $sort-icon-asc;
}

::v-deep .b-table thead th.sorting_desc {
  background-image: $sort-icon-desc;
}

::v-deep .b-table tbody td {
  border: none;
  background-color: #fff;
  padding: 0 40px;
  height: 50px;
  font-size: 15px;
  color: $samtek-black;
  vertical-align: middle;
}
::v-deep .b-table.table-striped tbody tr:nth-of-type(odd) > td {
  background-color: #fff;
}
::v-deep .b-table tbody tr td:first-child {
  font-weight: 700;
  color: $samtek-black;
}

::v-deep .id-column {
  width: 60px;
}
::v-deep .actions-column {
  width: 200px;
}

::v-deep .actions-column .btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: $samtek-black;
  border: none;
  border-radius: 20px;
  color: $samtek-yellow;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;

  .b-icon {
    color: inherit;
    vertical-align: middle;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: $samtek-yellow;
    color: $samtek-black;
    box-shadow: none;
  }
}

::v-deep .dropdown-menu {
  background-color: #fff;
  border: 1px solid $table-head-bg;
  border-radius: 8px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

::v-deep .dropdown-item {
  color: $samtek-grey;

  &:hover,
  &:focus {
    background-color: $center-bg;
    color: $samtek-grey;
  }
}

::v-deep .page-item.active .page-link {
  background-color: $samtek-yellow;
  border-color: $samtek-grey;
  color: $samtek-black;
}
::v-deep .page-link {
  background-color: #fff;
  color: $samtek-grey;
  border: 1px solid $table-head-bg;
  &:hover {
    background-color: $center-bg;
    color: $samtek-grey;
    border: 1px solid $table-head-bg;
    box-shadow: none;
  }
}
::v-deep .page-item.disabled .page-link {
  background-color: #fff;
  color: $samtek-grey;
  border: 1px solid $table-head-bg;
}

::v-deep tr {
  height: 50px;
}

.search-container {
  width: 250px;
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  color: $samtek-yellow;
}

.search-input {
  height: 40px;
  padding-left: 40px;
  font-size: 15px;
  color: $samtek-black;
  border-radius: 5px;
  border: 1px solid $samtek-grey;

  &:focus {
    border-color: $samtek-grey;
    box-shadow: none;
  }

  &::placeholder {
    color: $samtek-grey;
    font-size: 15px;
  }
}
</style>
